import { Entity } from "./entity";

export class ExportData extends Entity {
    
    username: string;
    name: string;  
    surname: string;  
    taxCode: string;
    mail: string;
    insertDate: string;
    role: string;    
    agencyCode: string;    
    agencyName: string;  
    vatNumber: string;
    lastAccess: string;
    forfetari: number;
    simulazioniSrl: string;
    schedaBudget: string;

    static newItem(): ExportData {
        let item = new ExportData();
        return item;    
    }

}

export class ExportDataSearchModel extends Entity /*implements Pagination*/ {
    
    companyId?: number;
}